<template>
  <v-flex sm10 offset-sm1>
    <v-container fluid>
      <v-flex>
        <v-card class="elevation-0 mb-5 pb-5">
          <div primary-title class="primary--text pa-2 mb-4 mt-3">
            <h3 class="display-1 mb-0 ml-3">{{ 'confirm.title' | t }}</h3>
          </div>
          <v-layout v-if="formload" row wrap>
            <v-flex text-md-center>
              <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
            </v-flex>
          </v-layout>
          <v-flex v-else md6 offset-md3 class="mt-4">
            <v-card class="elevation-0">
              <v-card-title primary-title>
                <v-flex v-if="status === 2">
                  <div class="text-xs-center mt-2 mb-2">
                    <v-icon dark color="green" x-large>check_circle</v-icon>
                  </div>
                  <div class="subheading mt-3 text-xs-center">{{ 'confirm.ok.title' | t }}</div>
                  <div class="subheading mt-3 text-xs-center">{{ 'confirm.ok.message' | t }}</div>
                  <div class="subheading mt-5 text-xs-center">
                    <v-btn color="primary ml-2" to="/home" dark>{{ 'confirm.ok.button' | t }}</v-btn>
                  </div>
                </v-flex>
                <v-flex v-if="status === 0 || status === 3 || status === 4">
                  <div class="text-xs-center mt-2 mb-2">
                    <v-icon dark color="red" x-large>error</v-icon>
                  </div>
                  <div class="subheading mt-3 text-xs-center">{{ 'confirm.ko.title' | t }}</div>
                  <div class="subheading mt-5 text-xs-center">
                    <v-btn color="primary ml-2" to="/shop" dark>{{ 'confirm.ko.button' | t }}</v-btn>
                  </div>
                </v-flex>
                <v-flex v-if="status === 1 || status === 5">
                  <div class="text-xs-center mt-2 mb-2">
                    <v-icon dark color="grey" x-large>help</v-icon>
                  </div>
                  <div class="subheading mt-3 text-xs-center">{{ 'confirm.info.title' | t }}</div>
                  <div class="subheading mt-5 text-xs-center">
                    <v-btn color="primary ml-2" to="/home" dark>{{ 'confirm.info.button' | t }}</v-btn>
                  </div>
                </v-flex>
              </v-card-title>
            </v-card>
          </v-flex>
        </v-card>
      </v-flex>
    </v-container>
  </v-flex>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      formload: true,
      status: 5,
      emission_date: "",
      id: 0,
      IVA: 21,
      iva_price: 0,
      total_price: 0
    };
  },
  computed: {
    ...mapGetters(["getServer", "getTokenHeader"])
  },
  methods: {
    ...mapActions(["setSession"])
  },
  created() {
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      this.$http
        .get(`${this.getServer}/orders/${this.id}`, this.getTokenHeader)
        .then(res => {
          this.status = res.data.status;
          if (res.data.product_set === 0) {
            const sessionstring = localStorage.getItem("session");
            const session = JSON.parse(sessionstring);
            session.user_type = 2;
            this.setSession(session);
            this.formload = true;
          }
        })
        .catch(error => {
          if (error && error.error && error.error == "notfound") {
            this.status = 1;
          }
          this.formload = true;
        });
    }
  }
};
</script>
